/** 带「全部」的筛选下拉（原在 eval/eval-tab.tsx，模拟场景与评测记录共用；菜单重组第二轮挪到 kit，评测记录不再引整个模拟场景页文件） */
import { Select as StyledSelect } from "@/components/ui/select";

export function FilterSel({
	label,
	value,
	onChange,
	opts,
	labelOf,
}: {
	label: string;
	value: string;
	onChange: (v: string) => void;
	opts: string[];
	/** 选项显示文字（枚举值转中文；不给就照原值） */
	labelOf?: (v: string) => string;
}) {
	return (
		<span className="flex items-center gap-1">
			{label}
			<StyledSelect aria-label={label} value={value} onChange={(e) => onChange(e.target.value)}>
				<option value="">全部</option>
				{opts.map((o) => (
					<option key={o} value={o}>
						{labelOf ? labelOf(o) : o}
					</option>
				))}
			</StyledSelect>
		</span>
	);
}

export const uniqStr = (xs: string[]) => Array.from(new Set(xs.filter(Boolean)));
